

export const showLoginDialog = (options = {}) => {
    const $loginModal = jQuery('#login-modal');
    $loginModal.modal('show');
    if (typeof options.onAuthorizedCallback === 'function') {

        $loginModal.one('polkurier:authorized', e => {
            e.preventDefault();
            $loginModal.modal('hide');
            options.onAuthorizedCallback(e);
        });
    }
};
